import { FiCircle } from 'react-icons/fi';
import { MdManageAccounts } from 'react-icons/md';

const collectionsNavigation = [
    {
        id: 'admin',
        title: 'Admin',
        type: 'collapse',
        icon: <MdManageAccounts size={20} />,
        children: [
            {
                id: 'language',
                title: 'Language',
                type: 'item',
                icon: <FiCircle size={12} />,
                navLink: '/language',
                action: 'read',
                resource: 'collections',
            },
            {
                id: 'other_bar',
                title: 'Other Bar',
                type: 'item',
                icon: <FiCircle size={12} />,
                navLink: '/other_bar',
                action: 'read',
                resource: 'collections',
            },
            {
                id: 'elc_users',
                title: 'ELC Users',
                type: 'item',
                icon: <FiCircle size={12} />,
                navLink: '/elc_users',
                action: 'read',
                resource: 'collections',
            },
        ],
    },
];

export default collectionsNavigation;
